import { checkForm } from './../../../../../../models/back-office-admin-common/customer-check-in.model';
import { group } from '@angular/animations';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FilterChange, FilterItem, InternalFilterGroup } from 'app/shared/models/filter-group.models';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { BehaviorSubject } from 'rxjs';
import { auditTime, tap } from 'rxjs/operators';

@Component({
    selector: 'app-radio-paginated',
    templateUrl: './radio-paginated.component.html',
    styleUrls: ['./radio-paginated.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioPaginatedComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild(CdkVirtualScrollViewport) viewPort: CdkVirtualScrollViewport;

  @Input() filter: InternalFilterGroup;
  @Input() dataToView: FilterItem[] = [];
  @Input() loaderId: string;
  @Input() totalCount: number;

  @Input() searchSettings: SearchSettings = {
    placeholder: 'Search...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  @Output() search = new EventEmitter<string>();
  @Output() nextData = new EventEmitter<any>();
  @Output() changeFilter = new EventEmitter<any>();
  filterOptions = new BehaviorSubject<FilterItem[]>([]);

  utilsFunction = UtilityFunctions;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataToView) {      
      //this.filterOptions.next([...this.filterOptions.value, ...this.dataToView]);
      const combined = [...this.filterOptions.value, ...this.dataToView];
      const unique = combined.filter((v, i, a) => a.findIndex(x => x.value === v.value && x.text === x.text) === i);
      this.filterOptions.next(unique);
    }
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.viewPort?.scrolledIndexChange.pipe(auditTime(300), tap(() => {
      if (this.filter.withPagination && this.totalCount > this.filterOptions.value.length) {
        this.nextBatch();
      }
    })).subscribe();
  }

  nextBatch() {
    const end = this.viewPort.getRenderedRange().end;
    const total = this.viewPort.getDataLength();
    if (end >= total) {
      this.nextData.emit(this.filterOptions.value.length);
    }
  }

  trackByIdx(i: number) {
    return i;
  }

  onChangeRadio(group: InternalFilterGroup, item: FilterItem) {
    group.selected = [item];
    this.changeFilter.emit(item.value);
  }

  onSearch(search: string) {
    this.filterOptions.next([]);
    this.search.emit(search);
  }

}
